// extracted by mini-css-extract-plugin
export default {"moreInfoCard":"MoreInfoCard_moreInfoCard__Ptolg"};